import React from "react"
import PropTypes from "prop-types"

import LoaderSection from '../app_components/LoaderSection';
import ConvoTeaserItem from './ConvoTeaserItem';
import ChatContainer from './ChatContainer';
import ChatAd from './ChatAd';

class ConvoListContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      dataLoaded: false,
      convoOpen: false,
      premiumUser: false
    }

    this.loadConvos = this.loadConvos.bind(this)
    this.renderConvos = this.renderConvos.bind(this)
    this.openConvo = this.openConvo.bind(this)
    this.closeChat = this.closeChat.bind(this)
  }

  componentDidMount() {
    this.loadConvos()
  }

  loadConvos() {
    $.ajax({
      url: `../getUserConvos`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          convos: JSON.parse(data.data.convos),
          old_convos_exist: JSON.parse(data.data.old_convos_exist),
          currentUser: JSON.parse(data.data.current_user),
          dataLoaded: true,
          premiumUser: data.data.premiumUser
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  renderConvos() {
    return this.state.convos.map((convo, i) => {
      if(i%10 === 0 && !this.state.premiumUser) {
        return (
          <div key={i}>
             <ConvoTeaserItem
               convo={convo}
               key={i}
               openConvo={this.openConvo}
               currentUser={this.state.currentUser}
               missingImg={this.props.missingImg}
             />
             <ChatAd />
          </div>
        )
      }
      return (
        <ConvoTeaserItem
          convo={convo}
          key={i}
          openConvo={this.openConvo}
          currentUser={this.state.currentUser}
          missingImg={this.props.missingImg}
        />
      )
    })
  }

  openConvo(convoId) {
    this.setState({
      convoOpen: true,
      convoIdOpen: convoId
    })
  }

  closeChat() {
    this.loadConvos()
    this.setState({
      convoOpen: false,
      convoIdOpen: ''
    })
  }

  render() {
    if(!this.state.dataLoaded) {
      return (
        <div>
          <LoaderSection />
        </div>
      )
    } else if (this.state.convoOpen) {
      return(
        <ChatContainer
          convoId={this.state.convoIdOpen}
          closeChat={this.closeChat}
          missingImg={this.props.missingImg}
          currentUser={this.state.currentUser}
         />
      )
    }
    return(
      <div>
        {this.renderConvos()}
      </div>
    )
  }

}

export default ConvoListContainer;
